import templateCollection from "@/vuex/modules/template-collection.module"

export default {
  templateCollection
}